import {
  Button,
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
}

export const InAppDownloadDialog = ({ open, onOpenChange }: Props) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md">
      <DialogHeader>
        <DialogTitle>Open in your browser to download</DialogTitle>
        <DialogDescription>
          Downloads aren't supported in this in-app browser. To save the video to your
          device:
        </DialogDescription>
      </DialogHeader>
      <ol className="list-decimal space-y-1.5 pl-5 text-sm text-zinc-700">
        <li>
          Tap the <strong>⋯</strong> menu in the top-right corner.
        </li>
        <li>
          Select <strong>Open in External Browser</strong> (or{" "}
          <strong>Open in Safari / Chrome</strong>).
        </li>
        <li>Try the download again from your default browser.</li>
      </ol>
      <DialogFooter>
        <Button className="w-full" onClick={() => onOpenChange(false)}>
          Got it
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
